<template>
  <div class="list-section">
    <!-- 顶部区域：搜索区域 -->
    <div class="search-bg">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item :label="$t('followOrder.text71')+'：'" class="search-label">
            <!-- 状态 1:提取审核中 2:转账审核中 3:提取审核驳回 4:转账审核驳回 5:完成 -->
            <el-select v-model="filters.status" placeholder="" clearable>
              <el-option :label="$t('followOrder.text103')" value="1" />
              <el-option :label="$t('followOrder.text104')" value="2" />
              <el-option :label="$t('followOrder.text105')" value="3" />
              <el-option :label="$t('followOrder.text106')" value="4" />
              <el-option :label="$t('followOrder.text107')" value="5" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :label="$t('proxy.text158')+'：'" class="search-label">
            <el-date-picker
              v-model="filters.applyTime"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              style="width: 100%"
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" @click="handleSearch" class="search-button">{{ $t('proxy.text13') }}</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 提现操作区域 -->
    <div class="withdraw-container">
      <el-row>
        <el-col>
          <el-button @click="openWithdrawDialog" type="primary" class="withdraw-button">{{$t('proxy.text162')}}</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 提现记录表格 -->
    <div class="table-container">
      <el-table :data="tableData" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" align="center" label="ID" />
        <el-table-column prop="amountDesc" align="center" :label="$t('followOrder.text110')" />
        <el-table-column prop="receiveAccountTypeDesc" align="center" :label="$t('followOrder.text132')" />
        <el-table-column prop="receiveAccountDesc" align="center" :label="$t('proxy.text263')" />
        <el-table-column prop="statusDesc" align="center" :label="$t('proxy.text153')" />
        <el-table-column prop="createTime" align="center" :label="$t('proxy.text158')" />
        <el-table-column prop="bizCheckTimeDesc" align="center" :label="$t('followOrder.text112')" />
        <el-table-column prop="checkTimeDesc" align="center" :label="$t('followOrder.text113')" :formatter="formatCell"/>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>

    <!-- 提现弹窗 -->
    <el-dialog :title="$t('followOrder.text130')" v-model="withdrawDialogVisible" width="480px" :show-close="true"    :close-on-click-modal="false" 
    @close="resetWithdrawForm">
      <div class="withdraw-dialog-content">
        <el-form :model="withdrawForm" label-width="120px">
          <el-form-item :label="$t('followOrder.text114') + '：'" class="withdraw-label">
            <el-col :span="16" class="dialog-value">{{ availableAmount }} USD</el-col>
          </el-form-item>
          <el-form-item :label="$t('followOrder.text131') + '：'" class="withdraw-label">
            <el-input v-model="withdrawForm.amount" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('followOrder.text132') + '：'" class="withdraw-label">
            <el-select v-model="withdrawForm.accountType" placeholder="" @change="updateAccounts">
              <el-option
                v-for="type in accountTypes"
                :key="type.value"
                :label="type.text"
                :value="type.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('proxy.text263') + '：'" class="withdraw-label">
            <el-select v-model="withdrawForm.accountNumber" placeholder="">
              <el-option
                v-for="account in filteredAccounts"
                :key="account.value"
                :label="account.text"
                :value="account.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="withdrawDialogVisible = false">{{$t('followOrder.text119')}}</el-button>
        <el-button type="primary" @click="submitWithdraw">{{$t('trade.text73')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import apiService from '@/api/request';
import { number } from 'mathjs';
// 国际化
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    const { proxy } = getCurrentInstance(); // 用于访问实例上的属性，如 $message
    const loading = ref(false);
    const store = useStore();
    const withdrawDialogVisible = ref(false);
    const availableAmount = ref(0); // 初始可提金额
    const filters = reactive({
      status: '',
      applyTime: []
    });
    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0
    });
    const withdrawForm = reactive({
      amount: '',
      accountType: '',
      accountNumber: ''
    });
    const tableData = ref([]);
    const accountTypes = ref([]); // 存储账号类型
    const availableAccounts = ref({}); // 存储所有可用账号

    const filteredAccounts = computed(() => {
      console.log('availableAccounts:', availableAccounts.value);
      // 根据选择的账号类型过滤可用账号
      const selectedType = withdrawForm.accountType;
      if (selectedType === 1) {
        return availableAccounts.value.web ? availableAccounts.value.web : [];
      } else if (selectedType === 6) {
        return availableAccounts.value.mt4 ? availableAccounts.value.mt4 : [];
      }
      return [];
    });

    const fetchData = async () => {
      loading.value = true;
      const params = {
        userToken: store.getters.userToken !== '' ? store.getters.userToken : 'x',
        page: pagination.currentPage,
        limit: pagination.pageSize,
        status: filters.status,
        createTimeStart: filters.applyTime ? (filters.applyTime.length ? filters.applyTime[0] : '') : '',
        createTimeEnd: filters.applyTime ? (filters.applyTime.length ? filters.applyTime[1] : '') : '',
      };

      try {
        const response = await apiService.withdrawalRecordList(params);
        const { withdrawalRecords, count } = response.data;
        tableData.value = withdrawalRecords;
        pagination.total = count;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleSizeChange = (newSize) => {
      pagination.pageSize = newSize;
      fetchData();
    };

    const handleCurrentChange = (newPage) => {
      pagination.currentPage = newPage;
      fetchData();
    };

    const openWithdrawDialog = async () => {
      withdrawDialogVisible.value = true;
      await fetchAvailableAmount(); // 获取可提金额
    };

    const fetchAvailableAmount = async () => {
      loading.value = true;

      const params = {
        usertoken: store.getters.userToken !== '' ? store.getters.userToken : 'x',
      };

      try {
        const response = await apiService.withdrawalInfo( params);
        if (response && response.data) {
          availableAmount.value = response.data.balance; // 设置可提金额
          accountTypes.value = response.data.accountType || []; // 确保为数组
          availableAccounts.value = response.data.accounts || {}; // 确保为对象
        }
      } catch (error) {
        console.error('Error fetching available amount:', error);
      } finally {
        loading.value = false;
      }
    };

    const updateAccounts = () => {
      // 当选择账号类型时，重置账号选择
      withdrawForm.accountNumber = ''; // 重置账号选择
    };

    const submitWithdraw = async () => {
      console.log('withdrawForm:', withdrawForm);

      const amountNumber = Number(withdrawForm.amount);

      // withdrawForm.amount如果不是纯数字，提示proxy.text288
      if (isNaN(amountNumber)) {
        proxy.$message.error(t('proxy.text288'));
        return;
      }

      if (!amountNumber || !withdrawForm.accountType || !withdrawForm.accountNumber) {
        proxy.$message.error(t('proxy.text286'));
        return;
      }

      // 判断金额是否小于0.01
      if (amountNumber < 0.01) {
        proxy.$message.error(t('proxy.text288'));
        return;
      }

      // 判断金额是否小于可提金额
      if (amountNumber > availableAmount.value) {
        proxy.$message.error(t('followOrder.text117'));
        return;
      }

      loading.value = true;

      const selectedAccountType = accountTypes.value.find(
        (type) => type.value === withdrawForm.accountType
      );

      const params = {
        usertoken: store.getters.userToken !== '' ? store.getters.userToken : 'x',
        // amount: 转成数字,
        amount:amountNumber,
        accountType: selectedAccountType ? selectedAccountType.value : '',
        receiverAccountId: withdrawForm.accountNumber, // 提现账号ID
      };

      try {
        const response = await apiService.withdrawalConfirm(params);
        if (response.status === 1) {
          proxy.$message.success(t('fundHistory.text58')); // 提现申请成功
          withdrawDialogVisible.value = false; // 关闭对话框
          loading.value = false;
          // 重置表单
          withdrawForm.amount = '';
          withdrawForm.accountType = '';
          withdrawForm.accountNumber = '';
          fetchData(); // 刷新数据
        } else {
          proxy.$message.error(response.message);
        }
      } catch (error) {
        console.error('Error submitting withdraw:', error);
      } finally {
        loading.value = false;
        // 重置表单
        withdrawForm.amount = '';
        withdrawForm.accountType = '';
        withdrawForm.accountNumber = '';
      }
    };

    onMounted(() => {
      fetchData();
    });

    const formatCell = (row, column, cellValue, index) => {
      return cellValue === '' || cellValue === null ? '--' : cellValue;
    };

    const resetWithdrawForm = () => {
      withdrawForm.amount = '';
      withdrawForm.accountType = '';
      withdrawForm.accountNumber = '';
    };

    return {
      loading,
      withdrawDialogVisible,
      availableAmount,
      filters,
      pagination,
      withdrawForm,
      tableData,
      accountTypes,
      availableAccounts,
      filteredAccounts,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
      openWithdrawDialog,
      submitWithdraw,
      formatCell,
      updateAccounts,
      resetWithdrawForm,
      t
    };
  },
};
</script>

<style lang="less" scoped>

.withdraw-dialog-content {
  padding: 10px 0;
}

.withdraw-container {
  background-color: #fff;
  text-align: left;
  height: 46px;
  padding-top: 0px;
  padding-left: 40px;
}

.withdraw-button {
  width: 100px;
  height: 30px;
}

.dialog-footer {
  padding-top: 20px;
  display: flex;
  justify-content: right;
}

.withdraw-label .el-form-item__label {
  width: 100px;
}

.dialog-row {
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
}
</style>
